import { defineComponent as n, createBlock as a, openBlock as r, unref as p, mergeProps as i, withCtx as m, createElementVNode as o } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const h = /* @__PURE__ */ n({
  name: "IconBill",
  __name: "IconBill",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const l = t;
    return (d, e) => (r(), a(p(c), i(l, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        o("path", { d: "M7.25 7A.75.75 0 0 1 8 6.25h8a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 7M8 9.75a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8M7.25 14A.75.75 0 0 1 8 13.25h4a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 14" }, null, -1),
        o("path", {
          "fill-rule": "evenodd",
          d: "M4.25 3.5A1.25 1.25 0 0 1 5.5 2.25h13a1.25 1.25 0 0 1 1.25 1.25v13.293a1.25 1.25 0 0 1-.366.884l-3.707 3.707a1.25 1.25 0 0 1-.884.366H5.5a1.25 1.25 0 0 1-1.25-1.25v-17m1.5.25v16.5h7.533v-3.72a1.25 1.25 0 0 1 1.25-1.25h3.717V3.75H5.75m12.41 13.03h-3.377v3.376l3.377-3.376",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  h as default
};
